import React, {Fragment} from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import {GoogleLogin, Text} from '../../components';
import {Form} from 'react-final-form';
import {connect} from 'react-redux';

function VerifyEmail(props){

  function onSubmit(params){
    props.resendVerificationEmail(params);
  }

  return(
    <div style={{display:'flex', justifyContent:'center', alignItems:'center', marginTop:'0px'}}>
    <div style={{position:'relative', width:'100%', height:'100vh', maxWidth:'600px', overflowY:'scroll', boxShadow:'0 0 15px 5px rgba(31, 73, 125, 0.8)'}}>
    <Typography onClick={()=>{props.logout()}} color='primary' style={{textDecoration:'underline', cursor:'pointer', position:'absolute', top:'10px', right:'20px'}}>{'Logout'}</Typography>
    <div style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'20px'}}><img style={{width:'30px'}} src='/images/logo.png'/></div>
    <Typography variant='h6' color='primary' style={{width:'100%', textAlign:'center', marginTop:'20px'}}>ProspectSafari</Typography>
    {<Form onSubmit={onSubmit} initialValues={{email:props.me.email}}>
        {form_props => (
          <form onSubmit={form_props.handleSubmit}>
          <Fragment>
            <Typography style={{width:'calc(100% - 100px)', marginLeft:'50px', textAlign:'center', marginTop:'50px'}}>We have sent you an email for verification. See the email for instructions. If you don’t see it, let us know at <a href='mailto:support@prospectsafari.com'>support@prospectsafari.com</a></Typography>
            <div style={{width:'calc(100% - 150px)', marginLeft:'75px', marginTop:'40px'}}><Text name='email' title='Email' error={props.error} helperText={(props.error==true)?'An account with this email already exists':null} /></div>
            <div style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'30px'}}><Button color='secondary' variant='contained' onClick={()=>{form_props.form.submit()}}>Resend</Button></div>
          </Fragment>
          </form>
        )}
    </Form>}
    <div style={{height:'100px'}}/>
    </div>
    </div>
  );
}

export default connect(ss, dd)(VerifyEmail);

function ss(state){
  return{
    me:state.account.me,
    error:state.account.verification_email_error
  }
}

function dd(dispatch){
  return{
    resendVerificationEmail:(params)=>{dispatch({type:"REQUEST_RESEND_VERIFICATION_EMAIL", payload:params});},
    logout:()=>{dispatch({type:"REQUEST_LOGOUT"})}
  }
}
